import { startApp } from "emukit";

import { GAMES, GameboyEmulator } from "./ts";

const BACKGROUND = "6f7066";

(async () => {
    const emulator = new GameboyEmulator();
    const gameTitle = document.getElementById("game-title");
    const gamesButton = document.getElementById("games-button");
    const gamesSelector = document.getElementById("games-selector");
    const gamesList = document.getElementById("games-list");
    let started = false;

    const updateGameTitle = () => {
        const name = emulator.loadedRomName?.trim() || "Brounou";
        if (gameTitle) {
            gameTitle.textContent = name;
        }
    };
    const closeGames = () => {
        gamesSelector?.setAttribute("hidden", "");
    };
    const openGames = () => {
        gamesSelector?.removeAttribute("hidden");
    };
    const loadGame = async (path: string) => {
        closeGames();
        if (started) {
            await emulator.loadGame(path);
            return;
        }
        started = true;
        await emulator.start({ romUrl: path });
    };

    emulator.bind("booted", updateGameTitle);

    if (gamesList) {
        for (const game of GAMES) {
            const button = document.createElement("button");
            button.type = "button";
            button.className = "games-entry";
            button.textContent = game.name;
            button.addEventListener("click", () => {
                void loadGame(game.path);
            });
            gamesList.appendChild(button);
        }
    }

    gamesButton?.addEventListener("click", openGames);
    gamesSelector?.addEventListener("click", (event) => {
        if (event.target === gamesSelector) {
            closeGames();
        }
    });
    document
        .getElementById("games-close")
        ?.addEventListener("click", closeGames);

    await emulator.init();
    startApp("app", {
        emulator: emulator,
        fullscreen: false,
        info: false,
        debug: false,
        keyboard: true,
        sections: [],
        background: BACKGROUND,
        backgrounds: [BACKGROUND]
    });

    window.emulator = emulator;
})();
